import { CrmFieldFilter } from "types/Models/crmFields";

/**
 * True when a condition carries at least one real operand value.
 *
 * Mirrors the backend's own "supplied operand" rule (CRMFieldFilter.get_supplied_operands):
 * a blank/whitespace string, an empty array, or NaN isn't a value - and `match` alone, with no
 * `values` picked, isn't a complete multi-select condition either. Without this check an
 * incomplete row would reach the backend, which rejects it and fails the whole group list fetch
 * instead of just that one condition.
 */
export const isCrmFilterComplete = (filter: CrmFieldFilter): boolean => {
  const hasText = (value?: string) =>
    value !== undefined && value.trim() !== "";
  const hasNumber = (value?: number) =>
    value !== undefined && !Number.isNaN(value);

  return (
    hasText(filter.equals) ||
    hasText(filter.contains) ||
    hasNumber(filter.min_value) ||
    hasNumber(filter.max_value) ||
    hasText(filter.date_from) ||
    hasText(filter.date_to) ||
    filter.is_checked !== undefined ||
    (Array.isArray(filter.values) && filter.values.length > 0)
  );
};
